import axiosInstance from './axiosInstance';
import BASE_URL from '../config/apiConfig';

const TEMPLATES_URL = `${BASE_URL}/templates`;

/**
 * Fetch all templates with optional filtering
 * @param {Object} params - Query parameters
 * @param {string} params.source_connector - Filter by source connector type
 * @param {string} params.destination_connector - Filter by destination connector type
 * @param {string} params.search - Search term to match in template name or description
 * @returns {Promise<Object>} Response with templates array and total count
 */
export const fetchAllTemplates = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.source_connector) {
      queryParams.append('source_connector', params.source_connector);
    }
    if (params.destination_connector) {
      queryParams.append('destination_connector', params.destination_connector);
    }
    if (params.search) {
      queryParams.append('search', params.search);
    }

    const url = queryParams.toString() 
      ? `${TEMPLATES_URL}?${queryParams.toString()}`
      : TEMPLATES_URL;

    const response = await axiosInstance.get(url);
    return {
      templates: Array.isArray(response.data?.templates) ? response.data.templates : [],
      total: response.data?.total || 0,
    };
  } catch (error) {
    console.error('Failed to fetch templates:', error);
    throw error;
  }
};

/**
 * Get template details by ID
 * @param {string} templateId - Template identifier
 * @returns {Promise<Object>} Full template details
 */
export const getTemplateById = async (templateId) => {
  try {
    const response = await axiosInstance.get(`${TEMPLATES_URL}/${templateId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch template ${templateId}:`, error);
    throw error;
  }
};
